import { getFieldNameFromEqlField } from '@modules/common/utils';
import { getDisplayNameFromField } from '@modules/common/utils/getDisplayNameFromField';
import { CooccurrenceIcon } from '@modules/quantify/components/CooccurrenceIcon';
import { QUANTIFY_COOCCURRING_HELP_DESK_ARTICLE } from '@modules/quantify/constants';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { FilterListRounded, OpenInNewRounded } from '@mui/icons-material';
import {
  Box,
  Button,
  Divider,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import pluralize from 'pluralize';

interface QuantifyCooccurrenceToggleTooltipProps {
  children: React.ReactElement;
}

export const QuantifyCooccurrenceToggleTooltip = ({
  children,
}: QuantifyCooccurrenceToggleTooltipProps) => {
  const shouldShowCooccurringDataPoints = useQuantifyStore(
    ({ query }) => query.isCoOccurring,
  );
  const groupBy = useQuantifyStore(({ query }) => query.groupByField);
  const groupByDisplayName = groupBy
    ? pluralize(getDisplayNameFromField(getFieldNameFromEqlField(groupBy)))
    : '';

  const renderToggleTooltipTitle = () => {
    return (
      <Stack alignItems="center" direction="row">
        <Box>
          <Typography variant="caption">
            Result includes: <FilterListRounded fontSize="small" /> Filtered{' '}
            {groupByDisplayName}{' '}
            {shouldShowCooccurringDataPoints && (
              <>
                + <CooccurrenceIcon /> Co-occurring {groupByDisplayName}
              </>
            )}
          </Typography>
        </Box>
        <Box>
          <Divider
            orientation="vertical"
            variant="middle"
            sx={{ height: '16px !important', mx: 1 }}
          />
        </Box>
        <Button
          variant="text"
          size="small"
          sx={{
            fontSize: '12px',
            display: 'inherit',
            whiteSpace: 'nowrap',
            minWidth: 'max-content',
            textTransform: 'none',
            color: 'inherit',
            '&:hover': {
              color: 'inherit',
              textDecoration: 'underline',
            },
          }}
          endIcon={<OpenInNewRounded fontSize="inherit" />}
          href={QUANTIFY_COOCCURRING_HELP_DESK_ARTICLE}
          target="_blank"
        >
          Learn more
        </Button>
      </Stack>
    );
  };
  return (
    <Tooltip
      title={renderToggleTooltipTitle()}
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            minWidth: 'max-content',
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};
